import React from 'react';
import { SelectBaseProps } from './types';
import SelectBase from './SelectBaseInput';

const MobileSelect: React.FC<SelectBaseProps> = (props) => {
    return <SelectBase {...props} renderOptions={props.renderMobileOptions} />;
};

export default React.memo(MobileSelect);
